<!--
  Full view of the agent object (cp.ProvisionAgent), 04-frontend.md §7.
  Exactly ONE shared component per active navItem — the exact shape of
  bm-billing-area-full.component.html (PAT §L.2).
-->
@if (navigationItems && initialized) {

    <!--
      FD-4 (nested Review Workbench): this container is the height-bound flex column that carries the
      OBC's own scroll. For the navItem 'contractAgents' the scroll is handed DOWN to the nested
      mvs-review-workbench instead — that instance binds neither autoFitViewport nor viewportOffsetPx
      and therefore resolves to height:100%, which only works while every ancestor up to the
      workbench pane is height-bound. Hence the modifier class instead of a blanket overflow-y:auto.
    -->
    <div class="cp-provision-agent-full mt-4"
         [class.cp-provision-agent-full--workbench]="activeNavigationItem?.action == 'contractAgents'">

        <!-- navItem "Kennzahlen" — the DEFAULT pane (business rule 1). -->
        @if (activeNavigationItem?.action == 'kpi') {
            <cp-provision-agent-kpi
                    [provisionAgentId]="objectIdentifier.objectId">
            </cp-provision-agent-kpi>
        }

        @if (activeNavigationItem?.action == 'baseData') {
            <cp-provision-agent-base-data
                    [provisionAgentId]="objectIdentifier.objectId">
            </cp-provision-agent-base-data>
        }

        <!-- navItem "Provisionskonfiguration": die Beratersicht auf die aufgelöste
             Provisionskonfiguration — Steckbrief, Stichtagswahl, je Komponente ein Block mit den
             Zuordnungen in Entscheidungsreihenfolge und dem Herkunfts-Chip je Wert. Reine
             Auskunft: kein Bearbeiten, keine Beträge, keine Simulation. -->
        @if (activeNavigationItem?.action == 'configuration') {
            <cp-provision-agent-configuration
                    [provisionAgentId]="objectIdentifier.objectId">
            </cp-provision-agent-configuration>
        }

        <!-- navItem "Konten & Salden": the full account statement per Konto — head balance,
             running balance per row and the manual booking / transfer dialogs. Replaces the two
             former navItems 'balance' and 'transactions'. -->
        @if (activeNavigationItem?.action == 'account') {
            <cp-provision-agent-account
                    [provisionAgentId]="objectIdentifier.objectId">
            </cp-provision-agent-account>
        }

        <!-- navItem "Verträge / Haftungen": the Provisionssätze of this Abrechnungskonto; carries
             all three §7 action dialogs (Betrag überschreiben, Berater wechseln, Satz manuell
             anlegen), all of them writing on /cp/provisionContractAgents. The cp_agentChange right
             comes from the Base component, where it defaults to GRANTED (optimistic) and is
             demoted on a 403 from the server — see CpFeatureRight. -->
        @if (activeNavigationItem?.action == 'contractAgents') {
            <cp-provision-agent-contract-agents
                    [provisionAgentId]="objectIdentifier.objectId"
                    [provisionAgentName]="dto?.name"
                    [canAgentChange]="canAgentChange">
            </cp-provision-agent-contract-agents>
        }

        @if (activeNavigationItem?.action == 'payouts') {
            <cp-provision-agent-payouts
                    [provisionAgentId]="objectIdentifier.objectId">
            </cp-provision-agent-payouts>
        }

        <!-- navItem "Abrechnungen": the final Provisionsabrechnungen (cp.ProvisionAgentStatement) of
             this Abrechnungskonto with download and "Neu ausstellen" (reason dialog below). -->
        @if (activeNavigationItem?.action == 'statements') {
            @if (!canAgentStatement) {
                <p-message severity="warn" styleClass="w-full mb-3">
                    <span class="text-sm">
                        Neuausstellung gesperrt: Der Server hat das Recht „cp_agentStatement“ für Sie verweigert.
                    </span>
                </p-message>
            }
            <cp-provision-agent-statements #statementsList
                    [provisionAgentId]="objectIdentifier.objectId"
                    [canReissue]="canAgentStatement"
                    (reissueRequested)="handleReissueRequested($event)">
            </cp-provision-agent-statements>
        }

        @if (activeNavigationItem?.action == 'groups') {
            <cp-provision-agent-groups
                    [provisionAgentId]="objectIdentifier.objectId">
            </cp-provision-agent-groups>
        }

        @if (activeNavigationItem?.action == 'reserveCoverage') {
            <cp-provision-agent-reserve-coverage
                    [provisionAgentId]="objectIdentifier.objectId">
            </cp-provision-agent-reserve-coverage>
        }

    </div>

    <cp-provision-agent-statement-reissue-dialog
            [(visible)]="reissueDialogVisible"
            [statement]="reissueStatement"
            (reissued)="handleStatementReissued()"
            (onForbidden)="handleStatementForbidden()">
    </cp-provision-agent-statement-reissue-dialog>

}
